import {Injectable, NgZone} from '@angular/core';
import Swal from 'sweetalert2';
import {Router} from "@angular/router";
import {BsModalRef, BsModalService} from 'ngx-bootstrap/modal';
import {ConfirmationModalComponent} from '../../dashboard/query-management/modals/confirmation-modal/confirmation-modal.component';
import {BehaviorSubject, Subject} from 'rxjs';
import {ActiveToast, ToastrService} from 'ngx-toastr';
import {
  ConfirmationModalFcaComponentComponent
} from "../../dashboard/query-management/modals/confirmation-modal-fca-component/confirmation-modal-fca-component.component";

declare var $: any;

@Injectable({
  providedIn: 'root'
})
export class AlertService {
  private readonly _show = new BehaviorSubject<Boolean>(false);

  // Expose the observable$ part of the _todos subject (read only stream)
  readonly show = this._show.asObservable();

  //lock observable
  readonly lockNotifier = new Subject<boolean>();


  bsModalRef: BsModalRef;
  confirmationValue = new Subject<boolean>();
  toastState = new Subject<boolean>();

  constructor(public router: Router,private modalService: BsModalService,private customToast:ToastrService,private ngZone:NgZone) {
  }

  closeAlert() {
    Swal.close();
    this._show.next(false);
    // this.spinnerService.hide();
  }

  loading(text='Please Wait') {

    this._show.next(true);

  }

  showError(error='An error occurred!',text='',icon:any='error') {
    this._show.next(false);
    Swal.fire({
      icon: icon,
      title: error,
      text:text,
      allowOutsideClick: false,
    });
  }

  htmlMessage(icon,html) {
    return Swal.fire({
      html:html,
      icon: icon,
      allowOutsideClick: false,
    });
  }

  showErrorWithRedirect(path,error='An error occurred!') {
   return  Swal.fire({
      icon: 'error',
      title: error,
      allowOutsideClick: false,
    }).then(res=>{
      if(res.value){
        this.router.navigate([path])
      }
   });
  }

  showSuccess(message, bunttonText = 'Ok') {
    this._show.next(false);
    return Swal.fire({
      icon: 'success',
      html: message,
      focusConfirm: false,
      confirmButtonText: bunttonText,
      allowOutsideClick: false
    });
  }

  showConfirm(title = 'Are you sure', text = 'You won`t be able to revert this', confirmButtonText = 'Yes, delete it!',cancelButtonText='Cancel') {
    return Swal.fire({
      title,
      text,
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText,
      cancelButtonText
    });
  }

  confirmToProceed(title = 'Are you sure', text = 'You want to proceed?', confirmButtonText = 'Proceed',cancelButtonText='Cancel') {
    return Swal.fire({
      title,
      text,
      icon: 'question',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText,
      cancelButtonText
    });
  }


  showToast(icon,msg,pos:any='top'){

    let Toast = Swal.mixin({
      toast: true,
      position: pos,
      showConfirmButton: false,
      timer: 5000,
      timerProgressBar: false,
      showClass: {
        backdrop: 'swal2-noanimation', // disable backdrop animation
        popup: '',                     // disable popup animation
        icon: ''                       // disable icon animation
      },
      didOpen: (toast) => {
        toast.addEventListener('mouseenter', Swal.stopTimer);
        toast.addEventListener('mouseleave', Swal.resumeTimer)
      }
    });



    Toast.fire({
      icon: icon,
      title: msg
    })

  }

  confirmClose(modal) {
    this.showConfirm('Are you sure you want to cancel?','','Yes','No').then(res=>{
      if(res.value) $(modal).modal('hide');
    })
  }

  /**
   * @description reusable confirmation
   * @author Shovon
   * @param title of modal
   * @param message body
   * @param truthyText confirm button text
   * @param falsyText cancel button text
   * @example   onSubmit() {
    this.alerts.openConfirmationModal('test modal','test modal')
      .subscribe(
        (res:boolean)=>{console.log('clicked value',res);}
        )
  }
   */
  openConfirmationModal(title,message,truthyText='Proceed',falsyText='Cancel') {
    const initialState = {
      title: title,
      message: message,
      truthyText:truthyText,
      falsyText:falsyText,
    };
    this.bsModalRef = this.modalService.show(ConfirmationModalComponent, {initialState,backdrop:'static',keyboard:false,class:'modal-dialog-centered'});
    return this.confirmationValue.asObservable()
  }
  openConfirmationModalfca(title,message,truthyText='Proceed',falsyText='Cancel',uniqueId,fcaTypeId,param,fcaRequestId,failMessage,comp) {
    const initialState = {
      title: title,
      message: message,
      truthyText:truthyText,
      falsyText:falsyText,
      uniqueId:uniqueId,
      fcaTypeId:fcaTypeId,
      param:param,
      fcaRequestId:fcaRequestId,
      failMessage:failMessage,
      comp:comp
    };
    this.bsModalRef = this.modalService.show(ConfirmationModalFcaComponentComponent, {initialState,backdrop:'static',keyboard:false,class:'modal-dialog-centered'});
    return this.confirmationValue.asObservable()
  }

  emmitConfirmationValue(value){
    this.confirmationValue.next(value)
  }

  /**
   * @description toast from alert service (only for query list and child components)
   * @author Shovon
   * @example  subscribe
    this.alerts.fireToast().subscribe((res:any)=>{
      if(res.state=='show'){
        this.showToast(res.msg,res.type)
      }
      else this.configuredList.showtoast=0
    })
   * @example emit
   *
   * this.alerts.emmitToastState({state:'show',msg:'Unable to add a remark.',type:'error'})
   */

  fireToast() {
    return this.toastState.asObservable()
  }

  emmitToastState(value){
    this.toastState.next(value)
  }

  toast(type: 'success' | 'error' | 'info',message,title=null){
    this.ngZone.run(() => {
      let config = {closeButton : false,positionClass: 'toast-bottom-left'};
      if(type == 'success') this.customToast.success(message,title,config);
      else if(type == 'error') this.customToast.error(message,title,config)
      else if(type == 'info') this.customToast.info(message,title,config)
    })
  }

  showUploadToast(title){
    return this.customToast.info(
      `<div class="d-flex align-items-center justify-content-between">
                  <div>File uploading </div>
                  <div class="spinner-border spinner-border-sm text-info"></div>
            </div>`,
      title,{
      closeButton : false,
      disableTimeOut : true,
      enableHtml:true,
      positionClass: 'toast-top-right',
    }).toastId
  }
  showDownloadToast(title){
    return this.customToast.info(
      `<div class="d-flex align-items-center justify-content-between">
                  <div>File downloading </div>
                  <div class="spinner-border spinner-border-sm text-info"></div>
            </div>`,
      title,{
        closeButton : false,
        disableTimeOut : true,
        enableHtml:true,
        positionClass: 'toast-top-right',
      }).toastId
  }

  closeUploadToast(toastId: number){
    this.customToast.clear(toastId)
  }

}
